
export const campaignConfig = {
    host: `https://campaign-hub.penroseza.com`,
}

export const uMobileConfig = {
    host: `https://my-umobile-api.goodgamingco.com`,
    subscribeUrl: `https://u-pay-dcb.u.com.my/dynamicpe/flow?flow=subscribe`,
    returnUrl: `https://my-umobile-api.goodgamingco.com/subscriptions/return`,
}
